
  import Vue from "vue";
  import Cabecalho from "./components/Cabecalho.vue";
  import Rodape from "./components/Rodape.vue";

  import { Component } from "vue-property-decorator";

  @Component({
    components: {
      cabecalho: Cabecalho,
      rodape: Rodape
    }
  })
  export default class App extends Vue {}
